import styled, { css } from 'styled-components'
import {
  compose,
  system,
  color,
  space,
  layout,
  flexbox,
  border,
  shadow,
  position,
  typography,
  get,
  Scale,
} from 'styled-system'
import CSS from 'csstype'
import { SystemProps } from '../theme'

const isNumber = (n: number) => typeof n === 'number' && !isNaN(n)
const getWidth = (n: any, scale?: Scale) => get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%')

type Props = SystemProps & {
  cursor?: CSS.Property.Cursor
}

const systems = [
  system({
    opacity: {
      property: 'opacity',
      scale: 'opacities',
    },
  }),
  system({
    w: {
      property: 'width',
      scale: 'sizes',
      transform: getWidth,
    },
  }),
  system({
    h: {
      property: 'height',
      scale: 'sizes',
      transform: getWidth,
    },
  }),
  system({
    bgClip: {
      property: 'backgroundClip',
    },
  }),
  system({
    justifyContent: {
      property: 'justifyContent',
      scale: 'inlineAxis',
    },
  }),
  system({
    alignItems: {
      property: 'alignItems',
      scale: 'blockAxis',
    },
  }),
  system({
    bg: {
      property: 'background',
      scale: 'colors',
    },
  }),
]

const BaseBox = styled.div<Props>(
  compose(layout, space, color, flexbox, border, shadow, position, typography),
  ...systems
)

export const Box = styled(BaseBox)<Props>`
  ${props =>
    props.cursor &&
    css`
      cursor: ${props.cursor};
    `};
`

export const Flex = styled(Box)<Props>`
  display: flex;
`
